export default ($http) => ({
  fetchUnitTemplateList () {
    return $http.get('unit-templates')
  },
  fetchUnitTemplate (id) {
    return $http.get(`unit-templates/${id}`)
  },
  sortUnitTemplates (templates) {
    return $http.put('unit-templates/sort', { body: { templates } })
  },
  deleteUnitTemplate (id) {
    return $http.delete(`unit-templates/${id}`)
  },
  createUnitTemplate (body) {
    return $http.post('unit-templates', { body })
  },
  updateUnitTemplate (id, body) {
    return $http.put(`unit-templates/${id}`, { body })
  },
  fetchUnitTemplatesBySchool () {
    return $http.get('unit-templates/by-school')
  },
  updateUnitTemplatesBySchool (body) {
    return $http.put('unit-templates/by-school', { body })
  },
  copyUnitTemplate (id, body) {
    return $http.post(`unit-templates/${id}/copy`, { body })
  }
})
